import { useRef, useEffect, useState } from "react";
import {
  Button,
  Form,
  Input,
  Col,
  Row,
  Select,
  message,
  DatePicker,
} from "antd";
import "./FormatoDelegacionFirmaPlanCompraPDF.css"; // Aquí va el CSS que te paso abajo
import {
  getDataFormatoAceptacionPlanCompraPatti,
  postFormatoAceptacionPlanCompraPatti,
  putFormatoAceptacionPlanCompraPatti,
} from "../../../../services/financiero/plandecompras/getFormatoAceptacionPlanCompraPattiService";
import { useSelector } from "react-redux";
import AutoGrowingInput from "./AutoGrowingInput";
import dayjs from "dayjs";
import CampoPdfEditable from "./CampoPdfEditable";
const { Option } = Select;

const FormatoDelegacionPlanCompra = ({
  record,
  existe,
  registroData,
  onClose,
  actualizarDataRegistoLocal,
  updateData
}) => {
  const [form] = Form.useForm();
  const [listaProyectos, setListaProyectos] = useState([]);
  const [listaParticipantes, setListaParticipantes] = useState([]);
  const [listaParticipantesFiltrada, setListaParticipantesFiltrada] = useState(
    []
  );

  const [proyectoSeleccionado, setProyectoSeleccionado] = useState(null);
  const [tipoProyecto, setTipoProyecto] = useState(null);
  const [isEditing, setIsEditing] = useState(false);
  const [generandoPDF, setGenerandoPDF] = useState(false);
  const pdfRef = useRef();

  const usernameFromState = useSelector((state) => state.auth.user);
  const tipo_formato = 2;

  useEffect(() => {
    const fetchData = async () => {
      if (!record) return;

      form.resetFields(); // Limpia el formulario

      try {
        const resultData = await getDataFormatoAceptacionPlanCompraPatti(
          record
        );

        if (!resultData.status) {
          setListaProyectos([]);
          setListaParticipantes([]);
          return;
        }

        setListaProyectos(resultData.proyectos);
        setListaParticipantes(resultData.participantes);
        setListaParticipantesFiltrada(resultData.participantes);

        // Autocompletar datos si hay un solo proyecto
        if (resultData.proyectos.length === 1) {
          const proyecto = resultData.proyectos[0];
          setProyectoSeleccionado(proyecto.codigoProyecto);
          form.setFieldsValue({
            nombre_proyecto: proyecto.tituloProyecto,
            municipio: proyecto.municipio,
            departamento: proyecto.departamento,
            grupo_territorial: proyecto.grupoTerritorial,
            proyecto_selecionado: proyecto.codigoProyecto,
            codigo_pre: proyecto.codigoProyecto,
          });
        }

        // Autocompletar si hay un solo participante
        if (resultData.participantes.length === 1) {
          const participante = resultData.participantes[0];
          form.setFieldsValue({
            codigo_sir: participante.codigoSIRR,
            nombre_titular: participante.nombreTitular,
            numero_cedula: participante.numeroCedula,
            nombre_autoriza: participante.nombreTitular,
            cedula_autoriza: participante.numeroCedula,
            participante_selecionado: participante.codigoSIRR,
          });
        }

        if (existe && registroData?.detalle) {
          const detalle = {
            ...registroData.detalle,
            fecha: registroData.detalle.fecha
              ? dayjs(registroData.detalle.fecha)
              : null,
          };

          form.setFieldsValue(detalle);
          setIsEditing(true);
        } else {
          setIsEditing(false);
        }
      } catch (error) {
        console.error("❌ Error al obtener datos del formato:", error);
      }
    };

    fetchData();
  }, []);

  const onFinish = async (values) => {
    try {
      const user = usernameFromState?.username;

      const payload = {
        detalle: values,
        user,
      };

      let response;

      if (existe) {
        response = await putFormatoAceptacionPlanCompraPatti(
          registroData.id,
          payload
        );

        if (response?.success === true || response?.status === 200) {
          message.success("Formato actualizado y PDF almacenado correctamente");
          onClose();
          actualizarDataRegistoLocal();
        } else {
          message.warning("No se pudo actualizar el formato correctamente");
        }
      } else {
        //Insertamos el registro por primera vez del formato de delegación
        response = await postFormatoAceptacionPlanCompraPatti({
          ...payload,
          id_plan_compra: record,
          tipo_formato: tipo_formato,
        });

        //En caso de que la inserción sea correcta
        if (response?.success === true || response?.status === 200) {
          message.success("Formato registrado y PDF almacenado correctamente");
          onClose();
          actualizarDataRegistoLocal();
          updateData();
        } else {
          message.warning("No se pudo registrar el formato correctamente");
        }
      }
    } catch (error) {
      console.error("❌ Error en onFinish:", error.message || error);
      message.error("Hubo un error al registrar el formato");
    }
  };

  const handleChangeProyecto = (codigoProyecto) => {
    const proyecto = listaProyectos.find(
      (p) => p.codigoProyecto === codigoProyecto
    );

    if (proyecto) {
      form.setFieldsValue({
        nombre_proyecto: proyecto.tituloProyecto,
        municipio: proyecto.municipio,
        departamento: proyecto.departamento,
        grupo_territorial: proyecto.grupoTerritorial,
        proyecto_selecionado: proyecto.codigoProyecto,
        codigo_pre: proyecto.codigoProyecto,
      });

      form.setFieldsValue({
        participante_selecionado: null,
        nombre_titular: null,
        numero_cedula: null,
      });
      // Filtrar participantes del proyecto
      const participantesDelProyecto = listaParticipantes.filter(
        (p) => p.codigoProyecto === proyecto.codigoProyecto
      );

      setListaParticipantesFiltrada(participantesDelProyecto);
    }
  };

  const handleChangeParticipante = (codigoSIRR) => {
    const participante = listaParticipantes.find(
      (p) => p.codigoSIRR === codigoSIRR
    );
    if (participante) {
      form.setFieldsValue({
        codigo_sir: participante.codigoSIRR,
        nombre_titular: participante.nombreTitular,
        numero_cedula: participante.numeroCedula,
        nombre_autoriza: participante.nombreTitular,
        cedula_autoriza: participante.numeroCedula,
        participante_selecionado: participante.codigoSIRR,
      });
    }
  };

  return (
    <div className="container">
      <Form form={form} onFinish={onFinish} layout="vertical">
        <div ref={pdfRef} className="pdf-container">
          <img
            className="banner"
            src="Banner_membrete.png"
            alt="banner"
            style={{
              width: generandoPDF ? "100%" : "100%",
              height: generandoPDF ? "100px" : "auto",
            }}
          />

          <div id="selectores">
            <Row gutter={16}>
              <Col span={12}>
                <Form.Item
                  label="Seleccione proyecto"
                  name="proyecto_selecionado"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Seleccione un proyecto"
                    onChange={handleChangeProyecto}
                    disabled={listaProyectos.length === 1}
                  >
                    {listaProyectos.map((proyecto) => (
                      <Option
                        key={proyecto.codigoProyecto}
                        value={proyecto.codigoProyecto}
                      >
                        {proyecto.codigoProyecto}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label="Seleccione participante"
                  name="participante_selecionado"
                  rules={[{ required: true }]}
                >
                  <Select
                    placeholder="Seleccione un participante"
                    onChange={handleChangeParticipante}
                    disabled={listaParticipantes.length === 1}
                  >
                    {listaParticipantesFiltrada.map((p) => (
                      <Option key={p.codigoSIRR} value={p.codigoSIRR}>
                        {p.codigoSIRR} - {p.nombreTitular}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </div>

          <table className="excel-table">
            <thead>
              <tr>
                <th colSpan="8" className="title">
                  FORMATO DE DELEGACIÓN DE FIRMA PARA EL PLAN DE COMPRAS{" "}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td
                  colSpan="2"
                  style={{ height: "10px", verticalAlign: "middle" }}
                >
                  <strong>Nombre del proyecto productivo</strong>
                </td>
                <td colSpan="6">
                  <CampoPdfEditable
                    name="nombre_proyecto"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>Nombre persona en proceso de reincorporación</strong>{" "}
                </td>
                <td colSpan="6">
                  <CampoPdfEditable
                    name="nombre_titular"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>

              <tr>
                <td colSpan="1">
                  <strong>Departamento</strong>{" "}
                </td>

                <td colSpan="2">
                  <CampoPdfEditable
                    name="departamento"
                    generandoPDF={generandoPDF}
                  />
                </td>

                <td colSpan="1">
                  <strong>Municipio</strong>{" "}
                </td>

                <td colSpan="1">
                  <CampoPdfEditable
                    name="municipio"
                    generandoPDF={generandoPDF}
                  />
                </td>

                <td colSpan="1">
                  <strong>Grupo territorial</strong>{" "}
                </td>

                <td colSpan="2">
                  <CampoPdfEditable
                    name="grupo_territorial"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>

              <tr>
                <td colSpan="1">
                  <strong>Número de Cedula</strong>{" "}
                </td>
                <td colSpan="2">
                  <CampoPdfEditable
                    name="numero_cedula"
                    generandoPDF={generandoPDF}
                  />
                </td>

                <td colSpan="1">
                  <strong>Lugar de expedición: </strong>{" "}
                </td>
                <td colSpan="1">
                  <CampoPdfEditable
                    name="lugar_expedicion"
                    generandoPDF={generandoPDF}
                  />
                </td>

                <td colSpan="1">
                  <strong>Fecha</strong>{" "}
                </td>
                <td colSpan="2">
                  <Form.Item name="fecha" noStyle>
                    <DatePicker
                      format="YYYY-MM-DD"
                      placeholder="Ingresa fecha" // <- oculta el texto "Seleccionar fecha"
                      suffixIcon={null} // <- oculta el ícono del calendario
                      style={{ border: "none", width: "100%" }}
                    />
                  </Form.Item>
                </td>
              </tr>

              <tr>
                <td colSpan="8" className="title">
                  <strong>
                    ASUNTO: AUTORIZACIÓN PARA FIRMAR EL DOCUMENTO DE ACEPTACIÓN
                    DEL PLAN DE COMPRAS PARA EL FORTALECIMIENTO DEL PROYECTO
                    PRODUCTIVO
                  </strong>{" "}
                </td>
              </tr>

              <tr>
                <td
                  colSpan="8"
                  style={{
                    padding: "12px",
                    fontSize: "14px",
                    lineHeight: "1.6",
                    textAlign: "justify",
                  }}
                >
                  <p>
                    Yo <AutoGrowingInput name="nombre_autoriza" />,
                    identificado(a) con el número de cédula{" "}
                    <AutoGrowingInput name="cedula_autoriza" /> expedida en{" "}
                    <AutoGrowingInput
                      minWidth={50}
                      name="lugar_cedula_autoriza"
                    />
                    , en pleno uso de mis facultades legales e intelectuales,
                    autorizo al/la señor(a){" "}
                    <AutoGrowingInput name="nombre_autorizado" />,
                    identificado(a) con el número de cédula{" "}
                    <AutoGrowingInput name="cedula_autorizado" /> expedida en{" "}
                    <AutoGrowingInput
                      minWidth={50}
                      name="lugar_cedula_autorizado"
                    />{" "}
                    para que en mi nombre y representación firme el documento de
                    aceptación del Plan de Compras para el proyecto productivo
                    de carácter individual o asociativo con código PREP-PP{" "}
                    <AutoGrowingInput name="codigo_pre" /> y código SIR{" "}
                    <AutoGrowingInput name="codigo_sir" />.
                  </p>
                  <p>
                    La presente autorización aplica dado que la persona aquí
                    suscrita no pueda atender de forma personal al operador en
                    el marco de la ejecución de la Asistencia Técnica.
                  </p>
                  <p>
                    <strong>Nota:</strong> La persona autorizada debe presentar
                    el documento de identidad en original; se anexa foto de la
                    misma como soporte.
                  </p>
                </td>
              </tr>

              <tr>
                <td colSpan="8" className="title">
                  <strong>AUTORIZADO POR:</strong>{" "}
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>Nombre completo:</strong>{" "}
                </td>

                <td colSpan="6">
                  <CampoPdfEditable
                    name="nombre_autoriza_por"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <strong>Firma:</strong>{" "}
                </td>

                <td colSpan="6">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "1px solid black",
                        width: "100%",
                        height: "50px",
                        marginBottom: "8px",
                      }}
                    ></div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>Cedula:</strong>{" "}
                </td>

                <td colSpan="6">
                  <CampoPdfEditable
                    name="cedula_autoriza_por"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>

              <tr>
                <td colSpan="8" className="title">
                  <strong>
                    ACEPTACIÓN DE LA DELEGACIÓN (Anexar copia de la cédula)
                  </strong>
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>Nombre completo:</strong>{" "}
                </td>

                <td colSpan="6">
                  <CampoPdfEditable
                    name="nombre_aceptacion_delegacion"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>
              <tr>
                <td colSpan="2">
                  <strong>Firma:</strong>{" "}
                </td>

                <td colSpan="6">
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <div
                      style={{
                        borderBottom: "1px solid black",
                        width: "100%",
                        height: "50px",
                        marginBottom: "8px",
                      }}
                    ></div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colSpan="2">
                  <strong>Cedula:</strong>{" "}
                </td>

                <td colSpan="6">
                  <CampoPdfEditable
                    name="cedula_aceptacion_delegacion"
                    generandoPDF={generandoPDF}
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ marginRight: "10px" }}
          >
            {existe ? "✏️ Actualizar registro" : "📄Guardar regisgtro"}
          </Button>
        </div>
      </Form>
    </div>
  );
};
export default FormatoDelegacionPlanCompra;
